import Button from './button/index.js';
import Card from './card/index.js';
import Loading from './loading/index.js';
import Icon from './icon/index.js';
import Tab from './tab/index.js';
import Dialog from './dialog/index.js';
import Steps from './steps/index.js';
import Input from './input/index.js';
import WCUse from './w-c-use/index.js'

export default {
  Button: Button,
  Card: Card,
  Loading: Loading,
  Icon: Icon,
  Tab: Tab,
  Dialog: Dialog,
  Steps: Steps,
  Input: Input,
  WCUse: WCUse
};
